import React, { Component } from 'react';
import { Alert, Button, Col, Flex, Form, Input, Layout, Row, Space } from 'antd';
import Card from 'antd/es/card/Card';
import Text from 'antd/es/typography/Text';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { Link } from 'react-router-dom';
import routesConfig from '../../../config/routes';

class _SettingsUser extends Component<IRootStoreProps> {
  componentDidMount() {
    this.props.store.user.self();
  }

  componentWillUnmount(): void {
    this.props.store.dispose();
  }

  render() {
    const { store } = this.props;

    return (
      <Card bordered={false} title="Настройки пользователя" style={{ marginBottom: 8 }}>
        {store.user.isAdmin && (
          <Link to={routesConfig.consoleUsers}>
            <Button type="primary">{'Консоль'}</Button>
          </Link>
        )}
        <Flex align="center">
          <Space size="large">
            <Flex vertical>
              <Text>{store.user?.data?.email}</Text>
              {store.user.isVerivield ? (
                <Text type="success">{'Email подтвержден'}</Text>
              ) : (
                <Text type="danger">{'Email не подтвержден'}</Text>
              )}
            </Flex>
            {!store.user.isVerivield &&
              (store.auth.isEmailConfirmInit ? (
                <Alert
                  message={'Email со сылкой для проверки отправлен'}
                  description={store.requestError}
                  type={'success'}
                  showIcon
                />
              ) : (
                <Button type="primary" loading={store.loading} onClick={store.auth.emailConfirmInit}>
                  {'Подтвердить Email'}
                </Button>
              ))}
          </Space>
        </Flex>
        {/* <Flex align="center"> */}
        {/* <Form name="control-hooks" style={{ maxWidth: 600, marginTop: 30 }}>
            <Form.Item name="note" label="Логин">
              <Input />
            </Form.Item> */}
        {/* <Form.Item name="gender" label="Gender" rules={[{ required: true }]}>
              <Select placeholder="Select a option and change input text above" onChange={onGenderChange} allowClear>
                <Option value="male">male</Option>
                <Option value="female">female</Option>
                <Option value="other">other</Option>
              </Select>
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.gender !== currentValues.gender}>
              {({ getFieldValue }) =>
                getFieldValue('gender') === 'other' ? (
                  <Form.Item name="customizeGender" label="Customize Gender" rules={[{ required: true }]}>
                    <Input />
                  </Form.Item>
                ) : null
              }
            </Form.Item> */}
        {/* <Form.Item>
              <Button type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Form.Item>
          </Form> */}
        {/* </Flex> */}

        {/* <Text type="secondary">{'30.12.2024'}</Text> */}
      </Card>
    );
  }
}

export const SettingsUserPage: WithoutStore = withStore(observer(_SettingsUser));
